import React, { useEffect, useMemo, useRef, useState, memo } from "react";
import { TouchableOpacity, Text, View } from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import Ionicons from "@expo/vector-icons/Ionicons";
import { FlatList } from "react-native";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../utility/NavigationHelper";
import { AppFontStyle } from "../styles/AppFontStyle";
import { AppColors } from "../utility/AppColors";
import { CommonButton } from "../common/CommonButton";
import { AppScreens } from "../screens/Utility/AppScreens";
import HomeCardSkeleton from "./skeleton-components/HomeCardSkeleton";
import NoDataFound from "./NoDataFound";
import HomeItem from "../screens/Auth/WebScreens/Common/HomeItem";
import Card from "./Card";
import ImageComponent from "./ImageComponent";
import { AppImages } from "../utility/AppImages";
import KallOutWalkthrough from "./walk-through-common-components/myEventTooltips/KallOutWalkthrough";
import OpponenetWalkthrough from "./walk-through-common-components/myEventTooltips/OpponenetWalkthrough";
import WatchingWalkthrough from "./walk-through-common-components/myEventTooltips/WatchingWalkthrough";
import PastEventWalkthrough from "./walk-through-common-components/myEventTooltips/PastEventWalkthrough";
import OpponentWalkthrough from "./walk-through-common-components/myEventTooltips/OpponenetWalkthrough";

type CardsProps = {
  userData: any;
  heading: string;
  CardData: any;
  CardDataEmpty: any;
  // setIsGetTicket: any;
  accessToken: string;
  popularIndex?: number;
  setPopularIndex?: any;
  userProfileData?: any;
  showLoader?: boolean;
  eventID?: string;
  screenName?: string;
  fetchMoreEvents?: () => void;
  lastEvaluatedKey?: any;
  isFetchingMorePopularEvents?: boolean;
  eventlimit?: number;
  scrollViewRef?: any;
};

const ITEM_WIDTH = 320;
const ITEM_SPACING = 20;
const CONTAINER_PADDING = 20;

const Cards: React.FC<CardsProps> = ({
  userData,
  heading,
  CardData,
  CardDataEmpty,
  showLoader = false,
  eventID = "",
  // setIsGetTicket,
  accessToken,
  popularIndex,
  setPopularIndex,
  userProfileData,
  screenName = "Home",
  fetchMoreEvents,
  lastEvaluatedKey,
  isFetchingMorePopularEvents,
  eventlimit,
  scrollViewRef,
}) => {
  const navigation = useNavigation();

  const flatListRef = useRef<FlatList<any>>(null);
  const deviceSize = useDeviceSize();

  useEffect(() => {
    if (CardData.length > 0 && popularIndex < CardData.length) {
      flatListRef.current?.scrollToIndex({
        index: popularIndex,
        animated: true,
        viewPosition: 0,
      });
    }
  }, [popularIndex, CardData]);

  const handleNextPress = () => {
    if (!CardData || CardData.length === 0) return;

    const newIndex = popularIndex + 1;

    if (newIndex >= CardData.length) return;

    setPopularIndex(newIndex);
    flatListRef.current?.scrollToIndex({
      index: newIndex,
      animated: true,
      viewPosition: 1,
    });

    if (
      newIndex >= CardData.length - 3 &&
      lastEvaluatedKey &&
      !isFetchingMorePopularEvents &&
      CardData.length >= eventlimit &&
      fetchMoreEvents
    ) {
      fetchMoreEvents();
    }
  };

  const handlePrevPress = () => {
    if (popularIndex === 0) return;

    const newIndex = popularIndex - 1;
    setPopularIndex(newIndex);
    flatListRef.current?.scrollToIndex({
      index: newIndex,
      animated: true,
      viewPosition: 1,
    });
  };

  return (
    <View
      style={{
        paddingVertical: 12,
      }}
    >
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          paddingHorizontal:
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? "3.5%"
              : 0,
        }}
      >
        <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
          {heading === "My KallOuts" ? (
            <KallOutWalkthrough
              content={
                <Text
                  style={[
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? AppFontStyle.BOLD_ANYBODY_16
                      : AppFontStyle.BOLD_ANYBODY_24,
                    {
                      minWidth: 150,
                      color: AppColors.white,
                      marginTop: 10,
                    },
                  ]}
                >
                  {heading}
                </Text>
              }
            />
          ) : heading === "Opponents Challenges" ? (
            <OpponentWalkthrough
              content={
                <Text
                  style={[
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? AppFontStyle.BOLD_ANYBODY_16
                      : AppFontStyle.BOLD_ANYBODY_24,
                    {
                      minWidth: 150,
                      color: AppColors.white,
                      marginTop: 10,
                    },
                  ]}
                >
                  {heading}
                </Text>
              }
              scrollViewRef={scrollViewRef}
            />
          ) : heading === "Events I'm Watching" ? (
            <WatchingWalkthrough
              content={
                <Text
                  style={[
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? AppFontStyle.BOLD_ANYBODY_16
                      : AppFontStyle.BOLD_ANYBODY_24,
                    {
                      minWidth: 150,
                      color: AppColors.white,
                      marginTop: 10,
                    },
                  ]}
                >
                  {heading}
                </Text>
              }
            />
          ) : heading === "Past Events" ? (
            <PastEventWalkthrough
              content={
                <Text
                  style={[
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? AppFontStyle.BOLD_ANYBODY_16
                      : AppFontStyle.BOLD_ANYBODY_24,
                    {
                      minWidth: 155,
                      color: AppColors.white,
                      marginTop: 10,
                    },
                  ]}
                >
                  {heading}
                </Text>
              }
            />
          ) : (
            <Text
              style={[
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? AppFontStyle.BOLD_ANYBODY_16
                  : AppFontStyle.BOLD_ANYBODY_24,
                {
                  color: AppColors.white,
                  marginTop: 10,
                },
              ]}
            >
              {heading}
            </Text>
          )}
        </View>{" "}
        {/* {heading === "Recommended" && CardDataEmpty ? (
          <CommonButton
            title="Set Your Profile"
            onTap={() =>
              navigateToScreen(navigation, AppScreens.ChooseGameLikeScreen, {
                  username: userData.username,
                  flag: 1,
                })
            }
            buttonStyle={{
              paddingVertical: 14,
              backgroundColor: AppColors.themeColor_0A89AD,
              borderRadius: 50,
              shadowOpacity: 0,
              height: 35,
            }}
          />
        ) : null} */}
        {deviceSize === DEVICE_SIZES.XS ||
        deviceSize === DEVICE_SIZES.SM ? null : (
          <View style={{ flexDirection: "row", gap: 20 }}>
            <TouchableOpacity
              style={{
                backgroundColor: AppColors.lightBlack,
                borderRadius: 25,
                padding: 6,
                opacity: popularIndex === 0 ? 0.5 : 1,
              }}
              onPress={handlePrevPress}
              disabled={popularIndex === 0}
            >
              <ImageComponent
                url={AppImages.icArrowLeft}
                style={{
                  height: 24,
                  width: 24,
                }}
              />
            </TouchableOpacity>
            <TouchableOpacity
              style={{
                backgroundColor: AppColors.lightBlack,
                borderRadius: 25,
                padding: 6,
                opacity:
                  popularIndex < CardData.length - 1 ||
                  (lastEvaluatedKey && CardData.length >= eventlimit)
                    ? 1
                    : 0.5,
              }}
              onPress={handleNextPress}
              disabled={
                !(
                  popularIndex < CardData.length - 1 ||
                  (lastEvaluatedKey && CardData.length >= eventlimit)
                )
              }
            >
              <ImageComponent
                url={AppImages.icArrowRight}
                style={{ height: 24, width: 24 }}
              />
            </TouchableOpacity>
          </View>
        )}
      </View>

      {showLoader && !isFetchingMorePopularEvents ? (
        <HomeCardSkeleton />
      ) : (
        <View
          style={{
            flexDirection: "row",
            marginVertical: 14,
            alignSelf: CardDataEmpty ? "center" : "stretch",
            gap: 5,
          }}
        >
          {CardDataEmpty ? (
            <View style={{ flex: 1, alignItems: "center", paddingVertical: 20 }}>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_14,
                  {
                    color: AppColors.gray_C3C3C3,
                    textAlign: "center",
                    marginBottom: 5,
                  },
                ]}
              >
                {heading === "Popular Events"
                  ? "No popular events available right now"
                  : heading === "Upcoming"
                  ? "No upcoming events at the moment"
                  : heading === "Recommended"
                  ? "No events recommended based on your game preferences"
                  : heading === "Past Events"
                  ? "No past events found"
                  : "No events available"}
              </Text>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_12,
                  {
                    color: AppColors.gray_A6A3AA,
                    textAlign: "center",
                  },
                ]}
              >
                {heading === "Popular Events"
                  ? "Check back later for trending events"
                  : heading === "Upcoming"
                  ? "New events are posted regularly"
                  : heading === "Recommended"
                  ? "Update your game preferences to see personalized events"
                  : heading === "Past Events"
                  ? "Completed events will appear here"
                  : "New events will appear here soon"}
              </Text>
            </View>
          ) : (
            <View style={{ flex: 1, flexDirection: "row" }}>
              <FlatList
                horizontal
                data={CardData}
                ref={flatListRef}
                initialScrollIndex={popularIndex}
                showsHorizontalScrollIndicator={false}
                keyExtractor={(item, index) =>
                  item?.eventId || item?.id || `event-${index}-${item?.eventTitle || 'unknown'}`
                }
                getItemLayout={(data, index) => ({
                  length: ITEM_WIDTH,
                  // offset: ITEM_WIDTH * index,
                  offset:
                    (ITEM_WIDTH + ITEM_SPACING) * index -
                    (index === 0 ? 0 : ITEM_SPACING),
                  index,
                })}
                contentContainerStyle={{
                  paddingRight: ITEM_SPACING + CONTAINER_PADDING,
                }}
                renderItem={({ item, index }) => (
                  <Card
                    heading={heading}
                    userData={userData}
                    eventID={eventID}
                    index={index}
                    item={item}
                    accessToken={accessToken}
                    screenName={screenName}
                    userProfileData={userProfileData}
                    CardData={CardData}
                  />
                )}
                ItemSeparatorComponent={() => (
                  <View style={{ width: ITEM_SPACING }} />
                )}
              />
            </View>
          )}
        </View>
      )}
    </View>
  );
};

export default memo(Cards);
